import { Role } from "../models/enums/Role.enum";

export class User {
  public name: string;
  public username: string;
  public authorityType: string;
  public role: Role;

  constructor(msalAccountInfo: any) {
    this.name = msalAccountInfo.name ?? "";
    this.username = msalAccountInfo.username;
    this.authorityType = msalAccountInfo.authorityType ?? "";
    this.role = msalAccountInfo.role;
  }

  public get isUserStore(): boolean {
    return this.role === Role.Store;
  }

  public get isUserNoStore(): boolean {
    return this.role === Role.NoStore;
  }

  public get isUserHQ(): boolean {
    return this.role === Role.HQ;
  }

  public get isUserGlobalHQ(): boolean {
    return this.role === Role.GlobalHQ;
  }

  public get isUserBp(): boolean {
    return this.role === Role.Bp;
  }

  public get isUserGenerallyHQ(): boolean {
    return this.isUserHQ || this.isUserGlobalHQ || this.isUserNoStore || this.isUserBp;
  }

  public get isNotUserStore(): boolean {
    return !this.isUserStore;
  }

  public setRole(role: Role) {
    this.role = role;
  }

}
